module.exports = __webpack_public_path__ + "static/img/3_7_1.aa74e0d6.jpg";